import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./WhatsappButton.css";

export default function WhatsAppButton({
  phone = "447759818509",
  message = "Hello! I saw your Store and would like to buy your product.",
}) {
  const encodedMessage = encodeURIComponent(message);
  const waLink = `https://api.whatsapp.com/send?phone=${phone}&text=${encodedMessage}`;

  return (
    <div className="whatsapp-wrapper">
      <span className="whatsapp-tooltip">Chat on WhatsApp</span>

      <a
        href={waLink}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-btn"
      >
        <FaWhatsapp className="whatsapp-icon" />
        <span className="pulse-ring"></span>
      </a>
    </div>
  );
}
